export const environment = {
  production: false,
  staging: true,
  dev: false,
  siteUrl: 'https://myportal-stage.business.comcast.com',
  apiUrl: 'https://myportal-stage.business.comcast.com/api/v2',
  mocks: false,
  iscUrl: 'https://isc.staging.masergy.com?kc_idp_hint=comcast-idbroker',
  oktaClientId: '0oa2f4fbq5mLoir0C0h8',
  oktaIssuer:
    'https://login-stg.business.comcast.com/oauth2/auspgzv3c0HPDV7440h7',
};
